
   
import { $color } from "@/utils/cssVarUtils"
import { formAnatomy as parts } from "@chakra-ui/anatomy"
import type {
  PartsStyleFunction,
  SystemStyleFunction,
} from "@chakra-ui/theme-tools"


const baseStyleRequiredIndicator: SystemStyleFunction = (props) => {
  return {
    color: $color('scene-primary-normal'),
  }
}

const baseStyleHelperText: SystemStyleFunction = (props) => {
  return {
    color: $color('text-masked'),
    fontSize: "xs",
  }
}

const baseStyle: PartsStyleFunction<typeof parts> = (props) => ({
  container: { width: "100%", position: "relative" },
  requiredIndicator: baseStyleRequiredIndicator(props),
  helperText: baseStyleHelperText(props),
})

export const Form = {
  parts: parts.keys,
  baseStyle,
}